export default "__VITE_ASSET__S0moNJ5Q__"